import { createContext } from 'react';

export const OneSignalContext = createContext(null);
